import { createSlice } from '@reduxjs/toolkit'

const ourCoursesStatus = Object.freeze({
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
})

const initialState = {
    status: ourCoursesStatus.LOADING,
    errorMessage: null,
    courses: [],
}

const ourCoursesSlice = createSlice({
    name: 'ourCourses',
    initialState,
    reducers: {
        getOurCourses: state => {
            state.status = ourCoursesStatus.LOADING
        },
        getOurCoursesSuccess: (state, action) => {
            state.courses = action.payload
            state.status = ourCoursesStatus.SUCCESS
        },
        getOurCoursesError: (state, action) => {
            state.errorMessage = action.payload
            state.status = ourCoursesStatus.FAILURE
        },
    },
})

const {
    getOurCourses,
    getOurCoursesSuccess,
    getOurCoursesError,
} = ourCoursesSlice.actions

export const ourCoursesActions = {
    getOurCourses,
    getOurCoursesSuccess,
    getOurCoursesError,
}

export const ourCoursesSelectors = {
    isFetching: state => state.ourCourses.status === ourCoursesStatus.LOADING,
    errorMessage: state => state.ourCourses.errorMessage,
    hasError: state => state.ourCourses.status === ourCoursesStatus.FAILURE,
    courses: state => state.ourCourses.courses,
}

export const ourCoursesReducer = ourCoursesSlice.reducer
